






































































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { formatProductLink } from '@vue-storefront/core/modules/url/helpers'
import { prepareQuickSearchQuery } from '@vue-storefront/core/modules/catalog/queries/searchPanel'
import BaseFigure from './BaseFigure.vue'
import Modal from './Modal.vue'
import BaseCurrency from './BaseCurrency.vue'
import Search from './Search.vue'
import config from 'config'

export default Vue.extend({
	name: 'Calculator',
	props: {
		categoryProps: {
			type: String, 
			default: config.rootcategories.drukowanie
		}
	},
	filters: {
		formatPrice(input: string | number): string {
			return input ? input.toString().replace('.', ',') : ''
		}
	},
	components: {
		"BaseFigure": BaseFigure,
		Modal,
		BaseCurrency,
		Search
	},
	data: () => ({
		productsList: [] as Record<string, any>[],
		query: '',
		minQueryLength: 2,
		modalOpen: false,
		selectedItem: null as null | Record<string, any>,
		// Results
		printSavings: '',
		tonerSavings: '',
		grossOEMEditable: null as null | string,
		config
	}),
	computed: {
		...mapGetters({
      getCategoryProducts: 'category-next/getCategoryProducts',
    }),
		storeView () {
      return currentStoreView()
    },
		productLink () {
			if (this.selectedItem) {
				return formatProductLink(this.selectedItem, currentStoreView().storeCode)
			}
			return ''
    },
		filteredProducts() {
			if (this.query.length < 3) {
				return []
			}
      const queryByWord = this.query.split(' ')
			const result = this.productsList.filter((product) => {
				const keysToSearch = ['name', 'sku', 'description', 'part_number']
				let match = false

				for (const key of keysToSearch) {
					if (key in product) {
						const exactMatch = product[key].toLowerCase().includes(this.query.toLowerCase())
						const roughMatch = !exactMatch && queryByWord.every((word) => product[key].toLowerCase().includes(word.toLowerCase()))
						if (exactMatch || roughMatch) {
							match = true
							break
						}
					}
				}

				return match
			})
      return result
		},
		filteredProducts_v2() {     
        const requiredKeys = ['name', 'sku']   
        if(!this.query || this.query.length < 3) {
          return []
        }
        let searchQuery = prepareQuickSearchQuery(this.query)
        let startValue = 0;
        let size = 1000
        // this.start = startValue
        // this.readMore = false
        try {
          this.$store.dispatch('product/findProducts', {
            searchQuery,
            start: 0,
            size: size,
            options: {
              populateRequestCacheTags: false,
              prefetchGroupProducts: false
            }
          }).then(result => { 
            return result.items
          }).catch(err => {
            console.error(err)
            return []
          })
        } catch (err) {
					console.log(err)
        }
    }
	},
	beforeMount () {
		// TODO replace by search adapter - filteredProducts_v2 
    this.preFilterProducts()
	},
	methods: {
		async preFilterProducts() {
			const result = await this.$store.dispatch('product/list', {
				size: 10000,
				sort: 'priority:desc'
			});

			const products = result ? result.items : [];
			const requiredKeys = ['name', 'sku', 'cena_oem', 'price_incl_tax', 'kod_oem', 'final_price', 'wydajnosc', 'wydajnosc_oem']

			this.productsList = products.filter((item) => !item.is_archived && requiredKeys.every((key) => key in item))
		},
		buildSearchQuery(queryText: string) {
      let searchQuery = prepareQuickSearchQuery(queryText)
      return searchQuery
    },
		async makeSearch($event: string) {
		  this.query = $event
		  if (this.query !== '' && this.query !== undefined && this.query.length >= this.minQueryLength) {
        	let query = this.buildSearchQuery(this.query)

            try {
        	  const { items } = await this.$store.dispatch('product/list', {
			    size: 1000,
			    sort: 'priority:desc'
			  });

			const products = items ? items : [];
			const keysToSearch = ['name', 'sku', 'description', 'part_number']

			//this.productsList = products.filter((item: Record<string, any>) => requiredKeys.every((key: string) => key in item))

			this.productsList = products.filter((product) => {
			  const queryByWord = this.query.split(' ') 
			  let match = false
			  for (const key of keysToSearch) {
			    if (key in product && product[key].toLowerCase().includes(this.query.toLowerCase())) {
				  const exactMatch = product[key].toLowerCase().includes(this.query.toLowerCase())
				  const roughMatch = !exactMatch && queryByWord.every((word) => product[key].toLowerCase().includes(word.toLowerCase()))
				  if (exactMatch || roughMatch) {
					match = true
					break
				  }
			    }
			  }
		      return match
		    })
        } catch (err) {
          console.log(err, 'components-search')
        }
      } else {
        this.productsList = []
      }
		},
		handleSelectItem(item: Record<string, any>): void {
			this.selectedItem = item

			this.calculate(item)
			this.modalOpen = true
		},
		parseData(data: Record<string, any>): Record<string, number> {
			return Object.keys(data).reduce((acc: Record<string, any>, key) => {
				switch (typeof data[key]) {
					case 'number':
						acc[key] = data[key]
						break
					case 'string':
						if ([',', '.'].some((s) => data[key].includes(s))) {
							acc[key] = Number(parseFloat(data[key].replace(',', '.').replace(/[^0-9.]+/g, '')).toFixed(2))
						} else {
							acc[key] = parseInt(data[key])
						}
						break
				}

				return acc
			}, {})
		},
		calculate(item: Record<string, any>) {
			const data = {
				grossBP: item.final_price,
				grossOEM: this.grossOEMEditable || item.cena_oem || item.price,
				efficiencyBP: item.wydajnosc,
				efficiencyOEM: item.wydajnosc_oem
			}

			const { grossBP, grossOEM, efficiencyBP, efficiencyOEM } = this.parseData(data)

			if (!this.grossOEMEditable) {
				this.grossOEMEditable = grossOEM && grossOEM.toString().replace('.', ',')
			}

			this.printSavings = this.calculatePrintSavings(grossBP, grossOEM, efficiencyBP, efficiencyOEM)
			this.tonerSavings = this.calculateTonerSavings(grossBP, grossOEM, efficiencyBP, efficiencyOEM)
		},
		calculatePrintSavings(grossBP: number, grossOEM: number, efficiencyBP: number, efficiencyOEM: number): string {
			return `${Math.ceil(((grossOEM / efficiencyOEM - grossBP / efficiencyBP) / (grossOEM / efficiencyOEM)) * 100)} %`
		},
		calculateTonerSavings(grossBP: number, grossOEM: number, efficiencyBP: number, efficiencyOEM: number): string {
			return `${Math.ceil((grossOEM / efficiencyOEM - grossBP / efficiencyBP) * efficiencyBP)} zł`
		},
		handleModalClose(): void {
			this.selectedItem = null
			this.grossOEMEditable = null
			this.modalOpen = false
		}
	}
})
